<template>
    <Card :title="$t('labels.expenses')">
        <div class="card-body">
            <div class="row">
                <div class="col-lg-4">
                    <FormGroup :label="$t('labels.name')" required>
                        <Input
                            v-model="name"
                        />
                    </FormGroup>
                </div>
                <div class="col-lg-4">
                    <FormGroup :label="$t('labels.sum')" required>
                        <Input
                            v-model="sum"
                            type="number"
                        />
                    </FormGroup>
                </div>
                <div class="col-lg-4">
                    <FormGroup :label="$t('labels.type')">
                        <AppSelect
                            :model-value="type?.value"
                            :selected-value="type?.label"
                            @update:model-value="type = $event"
                            :options="expenseTypeOptions"
                            option-key="value"
                            option-value="label"
                            :can-be-empty="true"
                        />
                    </FormGroup>
                </div>
            </div>
        </div>
        <div class="card-footer d-flex justify-content-end">
            <Button color="indigo" @click="createExpense" :disabled="!name || !sum">
                {{ $t('buttons.create') }}
            </Button>
        </div>
    </Card>
</template>
<script>
import Card from "../../../../../components/new/CardComponent.vue";
import Input from "../../../../../components/new/form/Input.vue";
import FormGroup from "../../../../../components/new/form/group/FormGroup.vue";
import Button from "../../../../../components/new/button/AppButton.vue";
import AppSelect from "../../../../../components/new/form/select/AppSelect.vue";

import { httpClient } from "../../../../../services/HttpClient";
import { OrderExpenseTypeEnum } from "../../../../enums/OrderExpenseTypeEnum";

export default {
    name: "OrderExpenseCreatePage",
    components: {
        Card, Input, FormGroup, Button, AppSelect
    },
    emits: ['update'],
    data() {
        return {
            name: '',
            sum: 0,
            type: null,
            expenseTypeOptions: [
                { value: OrderExpenseTypeEnum.SMS_SENDING, label: this.$t('enums.OrderExpenseTypeEnum.sms_sending') },
                { value: OrderExpenseTypeEnum.MARKETPLACE_COMMISSION, label: this.$t('enums.OrderExpenseTypeEnum.marketplace_commission') },
                { value: OrderExpenseTypeEnum.PRODUCTS_COST, label: this.$t('enums.OrderExpenseTypeEnum.products_cost') },
            ],
        }
    },
    methods: {
        async createExpense() {
            await httpClient.post(`/projects/${this.$route.params.projectUuid}/crm/orders/${this.$route.params.orderUuid}/expenses`, {
                name: this.name,
                sum: this.sum,
                order_uuid: this.$route.params.orderUuid,
                type: this.type?.value ?? null,
            }).then(() => {
                this.name = '';
                this.sum = 0;
                this.type = null;
                this.$router.push({ name: 'OrderExpensesIndexPage' });
                this.$emit('update')
            })
        }
    }
}
</script>